/**
 * HistoricalSection - Componente para exibição de um histórico de dados.
 *
 * Este componente exibe uma lista de itens em um formato de grade, com cada item contendo uma data e um botão.
 * Quando o botão é clicado, uma função de callback é chamada com o índice do item clicado.
 *
 * @component
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.title - Título exibido no topo da seção.
 * @param {Array} props.data - Dados a serem exibidos no histórico. Cada item deve ser um objeto contendo `date` (string) e `value` (string).
 * @param {Function} props.onButtonClick - Callback chamado ao clicar em um botão. Recebe o índice do item clicado como parâmetro.
 * @param {Function} props.onDeleteClick - Callback chamado ao clicar no botão de excluir.
 * @example
 * const data = [
 *   { date: "2024-01-01", value: "Item 1" },
 *   { date: "2024-01-02", value: "Item 2" },
 * ];
 *
 * const handleButtonClick = (index) => {
 *   console.log(`Botão clicado no item ${index}`);
 * };
 *
 * <HistoricalSection title="Histórico" data={data} onButtonClick={handleButtonClick} />
 */
import React from "react";
import { Grid, Button, IconButton } from "@mui/material"; // Importação do Grid e Button
import DeleteIcon from "@material-ui/icons/Delete";
import "./classes.css";
import "./HistoricalSection.css";
import historicalDialogConstants from "../../constants/Dialogs/historicalDialogConstants";
import { useUser } from "../../context/userContext";
const HistoricalSection = ({ title, data, onButtonClick, onDeleteClick }) => {
  const { language } = useUser();
  return (
    <>
      <h3>{title}</h3>
      <Grid container spacing={1}>
        {data.map((el, index) => (
          <Grid item lg={4} xs={12} key={index}>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: "bold",
                    flexGrow: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    marginRight: "8px",
                  }}
                  title={
                    el.name ||
                    historicalDialogConstants.machine.EmptyName[language]
                  }
                >
                  {el.name ||
                    historicalDialogConstants.machine.EmptyName[language]}
                </span>
                <IconButton
                  style={{ padding: 5 }}
                  onClick={() => {
                    if (onDeleteClick) {
                      onDeleteClick(index);
                    }
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </div>
              <span style={{ fontSize: "0.75rem", display: "block" }}>
                {el.date}
              </span>
              <Button
                className="button-algorithm"
                onClick={() => onButtonClick(index)}
                fullWidth
                style={{ marginTop: "5px" }}
              >
                <span className="elValue">{el.value}</span>
              </Button>
            </div>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
export default HistoricalSection;
